import type { PriceTableLabels } from '@/components/service/PriceTable';
import { TAX_EXCLUDED_COUNTRIES } from '@/lib/tax/countries';

type ServicePriceTaxLabelKeys = {
  included: 'pricesVatIncl' | 'pricesSalesTaxIncl';
  notIncluded: 'pricesVatNotIncl' | 'pricesSalesTaxNotIncl';
};

const VAT_TAX_LABEL_KEYS: ServicePriceTaxLabelKeys = {
  included: 'pricesVatIncl',
  notIncluded: 'pricesVatNotIncl',
};

const SALES_TAX_LABEL_KEYS: ServicePriceTaxLabelKeys = {
  included: 'pricesSalesTaxIncl',
  notIncluded: 'pricesSalesTaxNotIncl',
};

export function getServicePriceTableTaxLabelKeys(countryCode: string): ServicePriceTaxLabelKeys {
  const code = countryCode.trim().toUpperCase();
  if ((TAX_EXCLUDED_COUNTRIES as readonly string[]).includes(code)) {
    return SALES_TAX_LABEL_KEYS;
  }
  return VAT_TAX_LABEL_KEYS;
}

export function buildServicePriceTableLabels(
  t: (key: string) => string,
  countryCode: string
): PriceTableLabels {
  const taxKeys = getServicePriceTableTaxLabelKeys(countryCode);

  return {
    caption: t('caption'),
    category: t('category'),
    maximumPrices: t('maximumPrices'),
    onEstimate: t('onEstimate'),
    other: t('other'),
    packingIncluded: t('packagingAndShippingIncluded'),
    packingNotIncluded: t('packagingAndShippingNotIncluded'),
    price: t('price'),
    service: t('service'),
    type: t('type'),
    vatIncluded: t(taxKeys.included),
    vatNotIncluded: t(taxKeys.notIncluded),
  };
}
